import { useCallback, useEffect, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";

import { ColorPickerProps } from "./types";
import { useClickOutside } from "@/hooks/ui";

import "./styles.scss";
import { checkValidHexColor } from "@/utils/formHelper";

const isSafeValue = (value: any) => {
  return !(value === null || value === undefined || value === "" || value === "#NaNNaNNaN");
};

export const ColorPicker = ({
  color,
  defaultColorValue,
  dataQA,
  id,
  // withDebounce,
  onChange,
}: ColorPickerProps) => {
  const popover = useRef();

  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  const handleHexColorPickerChange = useCallback(
    (newColor: string) => {
      if (!isSafeValue(newColor)) return;
      onChange && onChange(newColor);
    },
    [onChange]
  );

  const [squarePickerColor, setSquareColor] = useState(color);

  useEffect(() => {
    if (color === "") {
      setSquareColor(defaultColorValue);
    }
    if (!checkValidHexColor(color)) {
      return;
    }
    setSquareColor(color);
  }, [color]);

  return (
    <div
      className="picker"
      data-qa={dataQA}>
      <div
        className="swatch"
        data-testid="color-picker"
        id={`color-picker-${id}`}
        style={{ backgroundColor: squarePickerColor }}
        onClick={() => toggle(true)}
      />
      {isOpen && (
        <div
          className="popover"
          ref={popover}>
          <HexColorPicker
            color={color}
            onChange={handleHexColorPickerChange}
          />
        </div>
      )}
    </div>
  );
};
